import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import logoImg from "../../images/logo/v.png";
import downloadSvg from "../../images/Download.svg";

import { GradientSpan, H1, P3 } from "../../components/theme/text/Headings";
import { ButtonGradient } from "../../components/theme/Button";

import {
  Black,
  Blue,
  White,
  NeonGreen,
  Purple,
} from "../../components/theme/colors";

import { signOut } from "firebase/auth";
import { useAuth } from "../../services/AuthContext";
import { auth } from "../../services/firebase.config";
import dataCache from "../../services/DataCache";

const LoginBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 0 2vh;
  background: ${Black};
  position: relative;
`;

const TopContent = styled.div`
  margin-top: 30vh;
`;

const DownloadButton = styled.a`
  display: block;
  margin: 20px 0;
  text-decoration: none;

  img {
    width: 150px;
    height: auto;
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const DownloadApp = () => {
  const navigate = useNavigate();
  const { currentUserState } = useAuth();

  const handleSignOut = async () => {
    try {
      // Clear cached data for current user on sign out
      if (currentUserState) {
        dataCache.invalidate(`user-profile-${currentUserState.uid}`);
        dataCache.invalidate(`quiz-completion-*-${currentUserState.uid}`);
      }

      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.log("sign out error", error);
    }
  };

  return (
    <LoginBody>
      <Container>
        <Row>
          <Col
            lg={{ offset: 4, span: 4 }}
            md={{ offset: 3, span: 6 }}
            sm={{ offset: 2, span: 8 }}
            xs={{ span: 12 }}
            className="text-align-center"
          >
            <TopContent>
              <img
                src={logoImg}
                alt="Vibe Check Logo"
                style={{ height: "60px" }}
              />
              <P3 className="mt-20">
                <GradientSpan
                  $background={NeonGreen}
                  $transitionBackground={Blue}
                >
                  Your answers were saved!
                </GradientSpan>
              </P3>
              <H1 className="mt-15" color={White}>
                Download the Vibe Check app to see your scores.
              </H1>

              <DownloadButton
                href="https://apps.apple.com/us/app/vibe-check-compatibility-quiz/id6755138167"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={downloadSvg} alt="Download on the App Store" />
              </DownloadButton>

              <ButtonGradient
                className="mt-50"
                width="100%"
                $background={Blue}
                $transitionBackground={Purple}
                onClick={handleSignOut}
              >
                Sign Out
              </ButtonGradient>
            </TopContent>
          </Col>
        </Row>
      </Container>
    </LoginBody>
  );
};

export default DownloadApp;
